---
en:
  production_scheduling:
    dialog:
      close: Close
      day_ahead_hint: '"Zero-load for tomorrow" and "Specific load for tomorrow" only affect the day-ahead bid sent before the noon deadline. Today''s hours and continuous/instant updates are not changed.'
      end_date: End date
      end_hour: End hour
      instant_send_note: Confirming delivers the intervals falling within the next {days} days to the market immediately via the InstantSender (instant operations plan). Later intervals reach the market through the automatic flow once they enter that window. The planned production updates in the Forecast tab's Volume and Price chart.
      instant_send_out_of_window: The selected range starts beyond the {days}-day market submission window, so nothing is delivered to the market immediately. The override still updates the forecast and the planned production, and reaches the market through the automatic flow once it enters the window.
      instant_send_partial_window: The selected range extends past the {days}-day market submission window. The intervals inside the window are delivered to the market immediately; the later ones are not, and reach the market through the automatic flow once they enter the window.
      override_type: Override type
      production_mw: Production (MW)
      send: Send to Kaia Trade
      start_date: Start date
      start_hour: Start hour
      success: Sent {count} intervals ({accepted} accepted, {rejected} rejected)
      timezone_hint: All times are in {timezone}
      title: Send override for {name}
    filter:
      all: All
      disabled: 'Off'
      enabled: 'On'
      label: 'Production plan:'
    om_dashboard_link: Open O&M dashboard
    override_types:
      specific_load_interval: Specific load for a time interval
      specific_load_tomorrow: Specific load for tomorrow
      zero_load_tomorrow: Zero-load for tomorrow
    production_plan_toggle:
      error: 'Failed to update production plan: {error}'
      label: Production plan
    send_override: Send override
    shadow_toggle:
      error: 'Failed to update shadow testing: {error}'
      label: Shadow testing
    table:
      actions: Actions
      company: Company
      continuous_forecast_enabled: Continuous forecast
      day_ahead_forecast_enabled: Day-ahead forecast
      forecast_query_enabled: Forecast query
      kaia_uuid: Kaia UUID
      last_error: Last known error
      last_override_sent: Last override sent
      last_prod_plan_sent: Last prod. plan sent to Trade
      name: Power plant
      production_simulation_plan_enabled: Production plan
      shadow_testing: Shadow testing
      use_price_dependent_bid: Price-dependent bid
    title: Prod. Scheduling
